// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconHardware4KQuality_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11.1061 15.551H9.61814V17.999H7.63414V15.551H2.54614V14.047L7.68214 6.54297H9.61814V13.903H11.1061V15.551ZM7.63414 13.903V11.343C7.63414 11.0443 7.63948 10.735 7.65014 10.415 7.66081 10.0843 7.67148 9.7803 7.68214 9.50297 7.70348 9.21497 7.71948 8.9963 7.73014 8.84697H7.66614C7.57014 9.0603 7.46348 9.27364 7.34614 9.48697 7.23948 9.68964 7.11681 9.8923 6.97814 10.095L4.38614 13.903H7.63414ZM21.7504 17.999H19.3984L16.0064 12.943 14.9344 13.791V17.999H12.8864V6.57497H14.9344V11.951C15.1477 11.6736 15.3664 11.4016 15.5904 11.135 15.8144 10.8576 16.0384 10.5803 16.2624 10.303L19.3504 6.57497H21.6704L17.4784 11.599 21.7504 17.999Z" class="svg-bg"/>
</svg>
`;
/**
 * IconHardware4KQuality is a generated icon component.
 */
let IconHardware4KQuality = IconHardware4KQuality_1 = class IconHardware4KQuality extends IconBaseElement {
    render() {
        return html `${IconHardware4KQuality_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconHardware4KQuality.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconHardware4KQuality = IconHardware4KQuality_1 = __decorate([
    customElement('zui-icon-hardware-4-k-quality')
], IconHardware4KQuality);
export { IconHardware4KQuality };
